// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetReadingsTarotReadingsGetQueryResponse } from "../models/tarotController/GetReadingsTarotReadingsGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type {
  QueryKey,
  QueryClient,
  UseQueryOptions,
  UseQueryReturnType,
} from "@tanstack/vue-query";
import { getReadingsTarotReadingsGet } from "../client/getReadingsTarotReadingsGet.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const getReadingsTarotReadingsGetQueryKey = () =>
  [{ url: "/tarot/readings" }] as const;

export type GetReadingsTarotReadingsGetQueryKey = ReturnType<
  typeof getReadingsTarotReadingsGetQueryKey
>;

export function getReadingsTarotReadingsGetQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getReadingsTarotReadingsGetQueryKey();
  return queryOptions<
    GetReadingsTarotReadingsGetQueryResponse,
    ResponseErrorConfig<Error>,
    GetReadingsTarotReadingsGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getReadingsTarotReadingsGet({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Get all readings for the current user
 * @summary Get Readings
 * {@link /tarot/readings}
 */
export function useGetReadingsTarotReadingsGet<
  TData = GetReadingsTarotReadingsGetQueryResponse,
  TQueryData = GetReadingsTarotReadingsGetQueryResponse,
  TQueryKey extends QueryKey = GetReadingsTarotReadingsGetQueryKey,
>(
  options: {
    query?: Partial<
      UseQueryOptions<
        GetReadingsTarotReadingsGetQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    (resolvedOptions && "queryKey" in resolvedOptions
      ? toValue(resolvedOptions.queryKey)
      : undefined) ?? getReadingsTarotReadingsGetQueryKey();

  const query = useQuery(
    {
      ...getReadingsTarotReadingsGetQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as UseQueryOptions<
      GetReadingsTarotReadingsGetQueryResponse,
      ResponseErrorConfig<Error>,
      TData,
      GetReadingsTarotReadingsGetQueryResponse,
      TQueryKey
    >,
    toValue(queryClient),
  ) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
